export class PageConstant {
  static readonly DEVICE_REGISTRATION_PAGE = 'device-registration';
  static readonly MENU_PAGE = 'menu';
  static LOGIN_PAGE: any | string;
  static readonly SUPPORT_PAGE = 'support';
}
